import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Kya aap Bhiwandi ke bahar delivery karte hain?",
    a: "Haan, bulk wholesale orders ke liye hum transport facility arrange kar dete hain. Retail orders sirf store pickup hain.",
  },
  {
    q: "Kala Sabun aur Peela Sabun mein kya farq hai?",
    a: "Kala sabun heavy oil aur jali kadhai ke liye sabse best hai. Peela sabun kapdon ke daag nikaalne ke liye design kiya gaya hai.",
  },
  {
    q: "Kya yahan loose detergent milta hai?",
    a: "Bilkul! Humare paas 5kg se lekar 50kg ki boriyon mein premium washing powder available hai, wo bhi factory rates par.",
  },
  {
    q: "Store kab band rehta hai?",
    a: "Hamari Main Branch Sunday ko puri tarah band rehti hai. Baaki branches bhi mostly Sunday ko closed rehti hain. Friday ko 1:00 PM se 4:00 PM tak Namaz break hota hai.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="section-pad bg-[#F3F4F6] border-t border-gray-200">
      <div className="msc-container max-w-4xl">
        <div className="text-center mb-10">
          <span className="badge-trust">Jaankari</span>
          <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl text-[#1F2937] leading-tight">
            Aksar Pooche Jaane Wale <span className="text-[#1E3A8A]">Sawaal</span>
          </h2>
          <p className="mt-3 text-[#4B5563] text-base sm:text-lg">
            Aapke sawaalon ke turant jawaab.
          </p>
        </div>

        <div className="grid gap-4 sm:gap-6">
          {FAQS.map((faq, i) => (
            <div key={i} className="card-base p-6 text-left flex gap-4 items-start">
              <div className="w-10 h-10 rounded-xl bg-[#F59E0B]/15 text-[#D97706] flex items-center justify-center shrink-0 mt-1">
                <HelpCircle className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-display font-bold text-lg text-[#1F2937]">
                  {faq.q}
                </h3>
                <p className="mt-2 text-sm sm:text-base text-[#4B5563] leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
